<template>
    <detail-header
        pretitle="InitiatorField"
        :title="initiatorField ? initiatorField.name : '&nbsp;'"
        :editable="true"
        :editMode="editMode"
        @editClick="onEditClick"
        @deleteClick="onDeleteClick"
        @saveClick="onSaveClick"
        @cancelClick="onCancelClick"
        @closeClick="$router.push(`/${$store.state.currentClient.cid}/aut/initiator-fields`)"
    />

    <div class="container-fluid">
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div v-if="successMessage" class="alert alert-success" role="alert">
            {{ successMessage }}
        </div>
        <div v-if="initiatorField">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <FormFields
                                :fields="fields"
                                v-model="initiatorField"
                                :editMode="editMode"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "../../components/DetailHeader.vue";
import { mapActions } from "vuex";
import FormFields from "../../components/FormFields.vue";
import Fields from "../../utils/field-constants/initiatorFields";
export default {
    name: "InitiatorField",
    components: { DetailHeader, FormFields},
    data() {
        return {
            editMode: false,
            initiatorField: null,
            snapshot: null,
            error: "",
            successMessage: "",
            fields: JSON.parse(JSON.stringify(Fields))
        };
    },
    beforeMount() {
        this.fetchInitiatorField();
        var self=this;
        this.$store.dispatch("aut/fetchInitiators").then(()=>{
            this.fields = this.fields.map((field)=>{
                if (field.name == 'name'){
                    field.editable = false;
                }
                if(field.name=="initiator"){
                    field.options=self.$store.state.aut.initiators.map((initiator)=>{
                        return {label: initiator.name, value: initiator.value }
                    })
                }
                return field
            })
        });
    },
    methods: {
        ...mapActions({
            readInitiatorField: "aut/readInitiatorField",
            updateInitiatorField: "aut/updateInitiatorField",
            deleteInitiatorField: "aut/deleteInitiatorField",
            showModal: "showModal",
        }),
        setEditMode(mode) {
            this.editMode = mode;
            this.successMessage = null;
            this.error = null;
        },
        async fetchInitiatorField() {
            let response={};
            if(!this.$route.params.data){
                try {
                    response = await this.readInitiatorField(this.$route.params.name);
                } catch (error) {
                    if (error.response.data.error)
                        this.error = error.response.data.error;
                    else this.error = error.message;
                    return;
                }
            }else{
                response["data"] = JSON.parse(this.$route.params.data)
            }
            this.initiatorField = await response.data;
            this.snapshot = { ...this.initiatorField };
        },
        onCancelClick() {
            this.setEditMode(false);
            this.initiatorField = { ...this.snapshot };
            this.error = null;
        },
        onEditClick() {
            this.setEditMode(true);
        },
        onDeleteClick() {
            const self = this;
            this.showModal({
                component: "confirm",
                data: {
                    title: "Delete Initiator Field",
                    message: `Are you sure you want to delete ${this.initiatorField.name}?`,
                    async confirm() {
                        try {
                            const response = await self.deleteInitiatorField(self.initiatorField);
                            self.$router.push("/aut/initiator-fields");
                            return response;
                        } catch (error) {
                            if (error.response.data.error)
                                self.error = error.response.data.error;
                            else self.error = error.message;
                            return;
                        }
                    },
                },
            });
        },
        async onSaveClick() {
            try {
                const response = await this.updateInitiatorField(this.initiatorField);
                this.setEditMode(false);
                this.snapshot = { ...this.initiatorField};
                this.successMessage = "Initiator Field updated successfully.";
            } catch (error) {
                if (error.response.data.error)
                    self.error = error.response.data.error;
                else self.error = error.message;
            }
        },
    },
};
</script>

<style>
</style>